import ElementsHall from './container';

export default ElementsHall;



// WEBPACK FOOTER //
// ./src/components/ElementsHall/index.js